import { createContext, useState } from 'react';

const PropStoreContext = createContext({});

export const PropStoreProvider = ({ value, children }) => {

    if (typeof value !== "object") {
        throw new Error("PropStoreProvider: value must be an object");
    }

    const [propStore, setPropStore] = useState(value);

    function updateProp(prop, value) {
        setPropStore({
            ...propStore,
            [prop]: value
        });
    }

    return (
        <PropStoreContext.Provider value={[propStore, updateProp]}>
            {children}
        </PropStoreContext.Provider>
    );
}

export default PropStoreContext;